import styled from '@emotion/styled';
import { Colors } from '../../../colors';
import { Link } from 'react-router-dom';

export const ListStyled = {
  ContainerEdit: styled.div<any>`
    display: flex;
    align-items: center;
    z-index: 10;
    justify-content: space-between;
  `,
  ContainerEditMail: styled.div<any>`
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  `,
  ContainerEditBooking: styled.div<any>`
    margin-right: 10px;
  `,
  ContainerEditTrash: styled.div<any>`
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding-right: 20px;
    border-right: 1px solid ${Colors.Black};
  `,
  ExpandedRow: styled.p<any>`
    font-family: 'EncodeSans-Regular';
    font-size: 12px;
    color: ${Colors.Black},
  `,
  CustomZoomDetail: styled(Link)<any>`
      cursor: pointer;
  `,
  CustomZoomDetailTitle: styled.p<any>`
    font-family: 'EncodeSans-Bold';
    font-size: 12px;
    color: ${Colors.MediumBlue};
  `,
  CustomRow: styled.p<any>`
    font-family: 'EncodeSans-Regular';
    font-size: 14px;
    word-break: break-word;
    color: ${Colors.Black};
  `,
  StatusRow: styled.p<any>`
    font-family: ${(props: any) => props.fontFamily};
    font-size: 14px;
    word-break: break-word;
    color: ${(props: any) => props.color};
  `,
  ContainerAttendeeList: styled.div<any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  `,
  ContainerAttendeeListCell: styled.div<any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  ContainerListAttendeesDescription: styled.p<any>`
    margin-left: 6px;
    text-decoration: underline;
    font-family: 'EncodeSans-Regular';
    font-size: 12px;
    color: ${Colors.Black},
  `,
  EditMessage: styled.p<any>`
    margin-left: 10px;
    font-size: 12px;
    font-family: 'EncodeSans-Regular';
    color: ${Colors.Unavailability}
  `,
  EditDelete: styled.p<any>`
    margin-left: 10px;
    font-size: 12px;
    font-family: 'EncodeSans-Regular';
    color: ${Colors.Unavailability};
  `,
  ContainerNoListUploaded: styled.div<any>`
 
  `,
  ContainerNoListDescription: styled.p<any>`
    font-family: 'EncodeSans-Regular';
    font-size: 12px;
    color: ${Colors.Black},
  `,
  ContainerCheckInOut: styled.div<any>`
    display: flex;
    flex-direction: column;
  `,
};

export const sxList = {
  tableHeader: {
    background: Colors.IceGrey,
  },
  tableHeaderText: {
    fontFamily: 'EncodeSans-Bold',
    fontSize: 12,
    color: Colors.Black,
  },
  tableBody: {
    background: Colors.White,
  },
  tableBodyText: {
    fontFamily: 'EncodeSans-Regular',
    fontSize: 14,
  },
  tablePagination: {
    background: Colors.White,
    '& .MuiTablePagination-displayedRows': {
      fontFamily: 'EncodeSans-Regular',
      fontSize: 12,
    },
  },
  expandedRow: {
    background: Colors.IceGrey,
    border: 0,
    paddingTop: '2px !important',
    paddingBottom: '10px !important',
  },
  servicesRow: {
    background: Colors.IceGrey,
    width: '20%',
    border: 0,
    paddingTop: '2px !important',
    paddingBottom: '10px !important',
  },
  expandedRowTitle: {
    fontFamily: 'EncodeSans-SemiBold',
    fontSize: 10,
    color: Colors.Black,
    border: 0
  },
  containerExpandedRow: {
    backgroundColor: Colors.IceGrey,
    borderBottom: '1px solid #e0e0e0',
  },
  containerExpandedRowCell: {
    backgroundColor: Colors.IceGrey,
    padding: '0 !important',
  }
};
